import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CompanyResponse, CompanySponsorResponse, SponsorResponse } from '../../../../@shared/models/response.module';
import { EndpointService } from '../../../../@shared/endpoints.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AddCompanySponsor } from './components/add-company-sponsor/add-company-sponsor';
import { DeleteModal } from '../../../../@shared/components/delete-modal/delete-modal';
import { ToastService } from '../../../../@core/services/toast.service';

@Component({
  selector: 'app-company-profile-sponsors',
  standalone: false,
  templateUrl: './company-profile-sponsors.html',
  styleUrl: './company-profile-sponsors.css'
})
export class CompanyProfileSponsors implements OnChanges {
  @Input() company: CompanyResponse;
  @Output() dataChanged = new EventEmitter<void>();

  companySponsors: CompanySponsorResponse[] = [];
  sponsors: SponsorResponse[] = [];
  loading: boolean = false;


  constructor(
    private endpointService: EndpointService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private toastService: ToastService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['company'] && this.company?.company_id) {
      this.getSponsors();
    }
  }

  getSponsors() {
    if (!this.company?.company_id) {
      return;
    }
    this.loading = true;
    this.endpointService.cor_coy_20(this.company.company_id).subscribe({
      next: (res) => {
        this.companySponsors = res.data || [];
        this.sponsors = this.companySponsors
          .map((cs) => cs.sponsor)
          .filter((s): s is SponsorResponse => s !== null && s !== undefined);
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.companySponsors = [];
        this.sponsors = [];
      }
    });
  }

  openAddModal() {
    const modalRef = this.modalService.open(AddCompanySponsor, { size: 'lg', centered: true });
    modalRef.componentInstance.company = this.company;
    modalRef.result.then((result) => {
      if (result) {
        this.getSponsors();
        this.dataChanged.emit();
      }
    }).catch(() => {});
  }

  openEditModal(sponsor: SponsorResponse) {
    const companySponsor = this.companySponsors.find(cs => cs.sponsor_id === sponsor.sponsor_id);
    if (!companySponsor) return;

    const modalRef = this.modalService.open(AddCompanySponsor, { size: 'lg', centered: true });
    modalRef.componentInstance.company = this.company;
    modalRef.componentInstance.editMode = true;
    modalRef.componentInstance.companySponsor = companySponsor;
    modalRef.result.then((result) => {
      if (result) {
        this.getSponsors();
        this.dataChanged.emit();
      }
    }).catch(() => {});
  }

  deleteSponsor(sponsor: SponsorResponse) {
    const companySponsor = this.companySponsors.find(cs => cs.sponsor_id === sponsor.sponsor_id);
    if (!companySponsor) return;

    const modalRef = this.modalService.open(DeleteModal, { centered: true });
    modalRef.componentInstance.description = this.translateService.instant('companyProfile.sponsors.deleteConfirm');
    modalRef.result.then((result) => {
      if (result) {
        this.endpointService.cor_coy_23(companySponsor.entry_id, this.company.company_id).subscribe({
          next: () => {
            this.toastService.success(this.translateService.instant('companyProfile.sponsors.deleteSuccess'));
            this.getSponsors();
            this.dataChanged.emit();
          },
          error: (err) => {
            console.error('Error deleting sponsor:', err);
            this.toastService.error(this.translateService.instant('companyProfile.sponsors.deleteError'));
          }
        });
      }
    }).catch(() => {});
  }

}
